import { Injectable } from "@angular/core";
import { DateRangeParam } from "../../models/DateRangeParam";
import { DefectivePartsPerMillionParam } from "../../models/DefectivePartsPerMillionParam";
import { UserPreference } from "../../models/UserPreference";
import { appSettings, errorMessages } from "../../settings";
import { AnalyticsService } from "../analytics.service";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class DefectivepartsService extends BaseService {
  constructor(
    private _analyticsService: AnalyticsService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) {
    super();
  }

  init(widget: any) {
    console.log("Defective Parts Per Million");
    widget.dataLoaded = false;
    widget.Title = "DPPM";
    let userPref: UserPreference = this._commonService.getUserPreference();
    let criteria: DefectivePartsPerMillionParam = new DefectivePartsPerMillionParam();
    let dateParam: DateRangeParam = new DateRangeParam();
    let setting = widget.widgetsettings;
    (dateParam.RangeValue = this._widgetHelper.GetSummaryType(
      setting.PickType
    ));
    (dateParam.RangeNumber = this._widgetHelper.GetSummaryTypeNo(
      setting.PickType
    ));

    this._analyticsService.getDates(dateParam).subscribe(
      data => {
        if (
          data.Start_Date.toString() != "0001-01-01T00:00:00" &&
          data.End_Date.toString() != "0001-01-01T23:59:59.999"
        ) {
          criteria.StartDate = new Date(data.Start_Date);
          criteria.EndDate = new Date(data.End_Date);
          criteria.CustomerId = userPref.CustomerId;
          criteria.FacilityId = userPref.FacilityId;
          criteria.SummaryType = setting.MonitorType;
          console.time("getDefectivePartsPerMillion");
          this._analyticsService.getDefectivePartsPerMillion(criteria).subscribe(
            (result: any) => {
              console.timeEnd("getDefectivePartsPerMillion");
              console.log("getDefectivePartsPerMillion", result);
              let Report_Periods = [];
              let DPPM = [];

              widget.chartOptions = this.chartOptions();
              widget.errorMessage = null;
              if (result && result.length > 0) {
                for (let i = 0; i < result.length; i++) {
                  let rptdate = "";
                  if (criteria.SummaryType == "D") {
                    rptdate = this._commonService.formatDate(
                      result[i].CYCLE_DATE,
                      appSettings.chartDayFormat
                    );
                  }
                  if (criteria.SummaryType == "W") {
                    rptdate =
                      "Wk " +
                      this._commonService.formatDate(
                        result[i].WEEK_START_DATE,
                        appSettings.chartWeekFormat
                      );
                  }
                  if (criteria.SummaryType == "M") {
                    rptdate = result[i].MONTH_ABBR_NAME;
                  }
                  if (criteria.SummaryType == "Q") {
                    //rptdate = (kpiData[i].QUARTER_NAME);
                    rptdate =
                      result[i].YEAR_NUMBER +
                      " QTR" +
                      result[i].QUARTER_NUMBER;
                  }
                  if (rptdate != '' && Report_Periods.indexOf(rptdate) == -1) {
                    Report_Periods.push(rptdate);
                  }

                  DPPM.push([rptdate, result[i].DPPM]);
                }
              } else {
                widget.errorMessage = errorMessages.noWidgetData;
              }
              this.addDataSeries(widget.chartOptions, DPPM, "Defective Parts Per Million", 'bar')
              widget.chartOptions.xAxis.data = Report_Periods;
              widget.chartOptions.xAxis.axisLabel.rotate = 45;
              //console.log(result)  ;
              widget.dataLoaded = true;
              //this._commonService.lastUpdatedTime = result.LastUpdateTime;
            },
            err => {
              console.timeEnd("getDefectivePartsPerMillion");
              console.log("getDefectivePartsPerMillion", err);
              widget.dataLoaded = true;
              widget.errorMessage = errorMessages.apiError;
            }
          );
        }
      },
      err => {
        console.log("getDates", err);
        widget.dataLoaded = true;
        widget.errorMessage = errorMessages.apiError;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/defectiveparts.service.ts